<template>
  <div class="container">
    <div class="text-center">
      <h2 class="title">{{ blok.title }}</h2>
      <div
        class="description"
        v-html="$storyapi.richTextResolver.render(blok.description)"
      ></div>
    </div>
    <nuxt-img
      quality="90"
      format="webp"
      placeholder
      :src="blok.image.filename"
      alt="404 image"
      class="img"
    />
    <nuxt-link :to="localePath('/')" class="font-fgb font-bold">
      {{ $t("Back to Homepage") }}
    </nuxt-link>
  </div>
</template>
<script>
export default {
  name: "Error404",
  props: {
    blok: {
      type: Object,
      required: false,
      default: {},
    },
  },
};
</script>
<style lang="scss" scoped>
.thank-you {
  @apply my-20;
}
.title {
  font: normal normal bold 55px/55px Montserrat;
  @media only screen and (max-width: 1024px) {
    font: normal normal bold 45px/55px Montserrat;
  }
  @media only screen and (max-width: 768px) {
    font: normal normal bold 35px/55px Montserrat;
  }
}
.description {
  font: normal normal bold 28px/35px Montserrat;
  max-width: 700px;
  margin: auto;
  @apply my-10;
  @media only screen and (max-width: 1024px) {
    font: normal normal bold 24px/35px Montserrat;
  }
  @media only screen and (max-width: 768px) {
    font: normal normal bold 20px/35px Montserrat;
    @apply my-6;
  }
}
.img {
  max-width: 550px;
  width: 100%;
  height: auto;
  margin: auto;
  @apply mb-6;
  object-fit: cover;
  border-radius: 0.75rem;
  @media only screen and (max-width: 1024px) {
    max-width: 400px;
  }
}
</style>
